export default "__VITE_ASSET__a984e9a6__"